import { Navigate, NonIndexRouteObject, useRoutes } from 'react-router-dom';
import { commonRoute } from './common/CommonRoute';
import { CommonNavigatePath } from './common/constants/CommonNavigatePath';
import { adminRoute } from './admin/AdminRoute';

/**
 * role 인터페이스
 */
interface Role {
  roleId: string;
}

/**
 * 라우트
 */
export interface Route extends NonIndexRouteObject {
  /**
   * 역할 목록
   */
  roles: Role[];
  /**
   * 인증 여부
   */
  isAuth: boolean;
  /**
   * 자식 노드
   */
  children?: Route[];
}

/**
 * 라우트 목록
 */
export const routes: Route[] = [
  ...commonRoute,
  ...adminRoute,
  {
    path: '/',
    element: <Navigate replace to={CommonNavigatePath.LOGIN} />,
    roles: [],
    isAuth: false,
  },
];

/**
 * 페이지 라우팅
 */
export const LayoutRoute: any = () => {
  const element = useRoutes([...routes]);
  return element;
};
